<template>
    <modal-overlay
        instance-class="consent-management"
        :id="id"
    >
        <div class="modal-overlay__content__item">
            <h1 class="heading1 custom-color-f">
                Wir benötigen Ihre Zustimmung
            </h1>
            Wenn Sie zustimmen, binden wir Dienste und Cookies zur Analyse, Beratung und Kartendarstellung ein.
            <ul>
              <li>
                <b>Nutzungsanalyse</b> misst das Besuchsverhalten per Cookie. Ihre IP-Adresse wird umgehend gelöscht, eine Datennutzung durch Google zu eigenen Zwecken ist untersagt.
              </li>
              <li v-if="showFdaConsent">
                <b>LiveChat „Frag die Apotheke“</b> ermöglicht Kontakt mit Experten von „Frag die Apotheke“.
              </li>
              <li>
                <b>HERE Maps</b> zeigt interaktive Karten.
              </li>
            </ul>
            <p>
            Sie können Ihre Auswahl jederzeit detailliert anpassen. Weitere Informationen und die Möglichkeit zum Widerruf finden Sie in unserer <a href="/Datenschutz" class="custom-color-b" target="_blank" rel="noopener noreferrer nofollow">Datenschutzerklärung</a>. Bei der Nutzung von Chat und Karten werden technische Daten (insb. Ihre IP-Adresse) an die Anbieter übermittelt und Cookies gesetzt. Hierfür gelten die Datenschutzhinweise der jeweiligen Anbieter.
            </p>
            <div class="consent-line">
                Websiteanalyse
                <label class="toggle-switch">
                    <input type="checkbox" v-model="gaConsent">
                    <span class="slider"></span>
                  </label>
            </div>
            <div
                v-if="showFdaConsent"
                class="consent-line"
            >
                Externe Inhalte („Frag die Apotheke“)
                <label class="toggle-switch">
                    <input type="checkbox" v-model="fdaConsent">
                    <span class="slider"></span>
                  </label>
            </div>
            <div class="consent-line">
                Karten (HERE Maps)
                <label class="toggle-switch">
                    <input type="checkbox" v-model="mapConsent">
                    <span class="slider"></span>
                  </label>
            </div>
            <div class="button-container">
                <button
                    class="button button--invert custom-color-b custom-border-color-b"
                    @click="dissent"
                >
                    Ablehnen
                </button>
                <button
                    class="button button--invert custom-color-b custom-border-color-b"
                    @click="save"
                >
                    Auswahl speichern
                </button>
                <button
                    class="button button--invert custom-color-b custom-border-color-b"
                    @click="consent"
                >
                    Zustimmen
                </button>
            </div>
            <div class="consent-imprint custom-border-color-b">
                <a href="/Impressum" target="_blank" rel="noopener noreferrer nofollow" class="custom-color-b">Impressum</a>
            </div>
        </div>
    </modal-overlay>
</template>

<script>
import ModalOverlay from '../modalOverlay/modalOverlay.vue';
import { eventHub, EVENT_NAMES } from '../../services/eventService';
import { setTrackingCookie, hasUserTrackingConsentGiven } from '../../services/trackingService.js';
import {
    setFdACookie,
    setMapCookie,
    hasUserFdAConsentGiven,
    hasUserMapConsentGiven
} from '../../services/consentService.js';

export default {
    name: 'ConsentManagement',
    components: { ModalOverlay },
    props: {
        id: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            gaConsent: hasUserTrackingConsentGiven() || false,
            fdaConsent: hasUserFdAConsentGiven() || false,
            mapConsent: hasUserMapConsentGiven() === true
        };
    },
    computed: {
        showFdaConsent() {
            return window.hasFdA && !window.hasChatId;
        }
    },
    created() {
        this.onModalOpen = (payload) => {
            if (payload.modalId === this.id) {
                this.syncMapConsentFromCookie();
            }
        };
        this.onMapConsentChanged = (value) => {
            this.mapConsent = value;
        };
        eventHub.$on(EVENT_NAMES.MODAL_OPEN, this.onModalOpen);
        eventHub.$on(EVENT_NAMES.MAP_CONSENT_CHANGED, this.onMapConsentChanged);
    },
    beforeDestroy() {
        eventHub.$off(EVENT_NAMES.MODAL_OPEN, this.onModalOpen);
        eventHub.$off(EVENT_NAMES.MAP_CONSENT_CHANGED, this.onMapConsentChanged);
    },
    methods: {
        syncMapConsentFromCookie() {
            this.mapConsent = hasUserMapConsentGiven() === true;
        },
        storeDecision(trackingValue, fdaValue, mapValue, event) {
            ModalOverlay.methods.closeModalClick.call(this, event);
            setTrackingCookie(trackingValue);
            setFdACookie(fdaValue);
            setMapCookie(mapValue);
        },
        save(event) {
            this.storeDecision(
                this.gaConsent,
                this.showFdaConsent ? this.fdaConsent : false,
                this.mapConsent,
                event
            );
        },
        consent(event) {
            this.storeDecision(true, this.showFdaConsent, true, event);
            this.gaConsent = true;
            this.fdaConsent = this.showFdaConsent;
            this.mapConsent = true;
        },
        dissent(event) {
            this.storeDecision(false, false, false, event);
            this.gaConsent = false;
            this.fdaConsent = false;
            this.mapConsent = false;
        }
    }
};
</script>

<style lang="scss">
.consent-management {
    .modal-overlay__content__item {
        padding: 16px 24px;
        flex-direction: column;

        h1 {
            font-size: 1.6rem;
        }

        @media #{$tablet} {
            max-width: 70ch;
        }

        a {
            font-weight: 400;
        }

        ul {
          list-style: disc;
          margin: 0.5em 1em 0.5em 1em;
        }

        li {
          margin-bottom: 0.5em;
        }

        b {
          font-weight: bold;
        }

    }

    .button-container {
        display: flex;
        justify-content: space-between;
        margin-top: 24px;
    }

    .button {
        @media (max-width: 572px){
            padding: 10px 5px;
            box-shadow: 1px 1px 0 #757575;
        }
    }

    p {
        margin-bottom: 5px;
    }
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
}

/* Versteckt die Standard-Checkbox */
.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* Der sichtbare Hintergrund des Schalters */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 34px;
}

/* Der bewegliche Kreis */
.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 1px;
  bottom: 1px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

/* Ändert die Farbe und Position, wenn die Checkbox aktiviert ist */
input:checked + .slider {
  background-color: #2196F3;
}

input:checked + .slider:before {
  transform: translateX(20px);
}

.consent-line {
  margin: 4px;

  label {
    float: right;
  }
}

.consent-imprint {
    margin-top: 20px;
    border-top: 1px;
    border-style: solid;
    text-align: center;
    font-weight: bold;
    font-size: 13px;
    padding-top: 5px;
}
</style>
